import * as React from 'react';
import { SimpleSticky } from '../SimpleSticky';
import { useModernStickyProps } from './useModernStickyProps';
import { jsx as _jsx } from "react/jsx-runtime";
export var ModernSticky = function ModernSticky(props) {
  var onBottomStuck = props.onBottomStuck,
    onTopStuck = props.onTopStuck,
    top = props.top,
    bottom = props.bottom,
    zIndex = props.zIndex,
    position = props.position,
    intersectionOffset = props.intersectionOffset,
    children = props.children,
    _props$testId = props.testId,
    testId = _props$testId === void 0 ? 'modernSticky' : _props$testId,
    root = props.root;
  var _useModernStickyProps = useModernStickyProps({
      onBottomStuck: onBottomStuck,
      onTopStuck: onTopStuck,
      root: root
    }),
    sentinelRef = _useModernStickyProps.sentinelRef,
    isOnBottomStuck = _useModernStickyProps.isOnBottomStuck,
    isOnTopStuck = _useModernStickyProps.isOnTopStuck;
  return /*#__PURE__*/_jsx(SimpleSticky, {
    ref: sentinelRef,
    zIndex: zIndex,
    bottom: bottom,
    top: top,
    testId: testId,
    isOnBottomStuck: isOnBottomStuck,
    isOnTopStuck: isOnTopStuck,
    position: position,
    intersectionOffset: intersectionOffset,
    children: children
  });
};
ModernSticky.displayName = 'ModernSticky';